@if (item && visible) {
  <div class="infoboxform-wrapper">
    <div class="close">
      <span aria-hidden="true">
        <app-custom-icons [type]="iconTypes.CLOSE" (click)="visible=!visible"></app-custom-icons>
      </span>
    </div>
    <div [innerHTML]="item.content" class="infoboxform-content"></div>
  </div>
}
